<template>
  <div :class="['input-main-select']">
    <label class="input-main-select__label" :for="label">
      <div v-if="value != null" @click="reset" class="input-main-select__reset">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g id="Menu / Close_MD">
            <path
              id="Vector"
              d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
              stroke="#000000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </svg>
      </div>
      <v-select
        :id="label"
        :placeholder="placeholder"
        :options="optionList"
        @input="onChange"
        :value="value"
        :label="labelName"
        :searchable="searchable"
        :disabled="disabled"
      >
      </v-select>
    </label>
    <div v-if="errorMessages.length">
      <p class="input-main-select__error">
        {{ errorMessages[0] }}
      </p>
    </div>
  </div>
</template>

<script>
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "InputMainSelect",
  props: {
    optionList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [Object, Number],
      default() {
        return {};
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    labelName: {
      type: String,
      default: "name",
    },
    label: {
      type: String,
      default: "",
    },
    setValue: {
      type: Object,
      default() {
        return {};
      },
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    change: {
      type: [Function, Boolean],
      default: false,
    },
  },
  methods: {
    onChange(value) {
      this.setValue[this.id] = value;
    },
    reset() {
      this.setValue[this.id] = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-main-select {
  color: $mainSecondColor;
  width: 100%;
  padding: 3px 3px 3px 20px;
  border: 1px solid $coffee;
  border-radius: 5px;
  position: relative;

  &__error {
    color: red;
    position: absolute;
    padding-top: 10px;
    font-size: 14px;
  }

  &__label {
    width: 100%;
    margin: 0;
  }

  &__reset {
    position: absolute;
    left: 3px;
    top: 8px;
    cursor: pointer;
  }
}

/deep/ .vs__dropdown-toggle {
  border: none;
  width: 100%;
}
/deep/.vs__selected-options {
  width: 80%;
}
/deep/ .vs__dropdown-option--highlight {
  background-color: $coffee;
}
/deep/ .vs__dropdown-menu {
  padding: 0;
  margin-top: 5px;
  width: fit-content;
  left: -20px;
  overflow-x: hidden;
}
/deep/ .vs__clear {
  display: none;
}
/deep/.vs__selected {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}
/deep/.vs__selected + .vs__search {
  display: none;
}

/deep/.vs--single.vs--open .vs__selected {
  position: static;
}
</style>
